var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMiscllenious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49.914,
    viewBox: "0 0 50 49.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-152 -356.068)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M152,383.123V380.2a3.324,3.324,0,0,0,.083-.42,23.066,23.066,0,0,1,2.858-9.83c4.6-8.174,11.627-12.624,21.011-13.2a23.214,23.214,0,0,1,12.775,2.891,24.587,24.587,0,0,1,12.88,17.68c.183.951.265,1.921.394,2.882v2.924a3.316,3.316,0,0,0-.083.42,23.443,23.443,0,0,1-2.853,9.828,24.665,24.665,0,0,1-17.708,12.85c-.954.183-1.927.265-2.891.394h-2.93a2.623,2.623,0,0,0-.377-.08,23.094,23.094,0,0,1-8.763-2.286,24.643,24.643,0,0,1-14-18.245C152.209,385.054,152.129,384.084,152,383.123Zm25-23.3a21.835,21.835,0,1,0,21.872,21.862A21.866,21.866,0,0,0,177,359.827Z",
    transform: "translate(0 -0.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M247.873,538.78a3.121,3.121,0,1,1-3.083-3.13A3.142,3.142,0,0,1,247.873,538.78Z",
    transform: "translate(-78.689 -157.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M337.473,538.753a3.121,3.121,0,1,1-3.112-3.1A3.143,3.143,0,0,1,337.473,538.753Z",
    transform: "translate(-157.352 -157.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M423.963,541.884a3.116,3.116,0,1,1,3.11-3.1A3.143,3.143,0,0,1,423.963,541.884Z",
    transform: "translate(-236.014 -157.74)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscllenious);
export default __webpack_public_path__ + "static/media/miscllenious.a1412079e8adc4601ad66fe7cbdeca2b.svg";
export { ForwardRef as ReactComponent };